/**
 * Search submit handler + legacy cleanup.
 *
 * Search matching is now client-side against the prebuilt index
 * (assets/search-matching.js), scoped to titles + SKU, so the old "title:"
 * query prefix is no longer added. This module now only:
 *   - carries the "include sold items" checkbox through on submit, and
 *   - defensively strips any leftover "title:" prefix from inputs/URLs
 *     (e.g. old bookmarks) so it never shows to the user.
 */

// Title-only search utility functions
function handleTitleOnlySearch(form) {
  // NOTE: We intentionally do NOT rewrite the visible input to "title:<term>"
  // anymore. Search matching is now done client-side against the prebuilt index
  // (assets/search-matching.js), scoped to titles + SKU, so the "title:" prefix
  // is unnecessary — and rewriting the input caused the visible "title:" flash
  // on submit. The form submits the raw query (?q=<term>).

  // Check for include sold items checkbox
  const includeSoldCheckbox = document.getElementById('search__sold-items__checkbox');
  if (includeSoldCheckbox && includeSoldCheckbox.checked) {
    // Add hidden input for include_sold parameter
    let hiddenInput = form.querySelector('input[name="include_sold"]');
    if (!hiddenInput) {
      hiddenInput = document.createElement('input');
      hiddenInput.type = 'hidden';
      hiddenInput.name = 'include_sold';
      form.appendChild(hiddenInput);
    }
    hiddenInput.value = 'true';
  }

  return true; // Allow form submission
}

function cleanSearchTermForDisplay(term) {
  if (typeof term === 'string' && term.startsWith('title:')) {
    return term.substring(6); // Remove 'title:' prefix
  }
  return term;
}

// Sync checkboxes based on URL state
function syncIncludeSoldCheckboxes() {
  const urlParams = new URLSearchParams(window.location.search);
  const includeSold = urlParams.get('include_sold') === 'true';

  // Update header checkbox
  const headerCheckbox = document.getElementById('search__sold-items__checkbox');
  if (headerCheckbox) {
    headerCheckbox.checked = includeSold;
  }

  // Update search page checkbox if it exists
  const searchPageCheckbox = document.getElementById('include-sold-out');
  if (searchPageCheckbox) {
    searchPageCheckbox.checked = includeSold;
  }
}

// Clean search terms and sync checkboxes on page load
document.addEventListener('DOMContentLoaded', function() {
  const searchInputs = document.querySelectorAll('input[name="q"]');
  searchInputs.forEach(function(input) {
    if (input.value && input.value.startsWith('title:')) {
      input.value = cleanSearchTermForDisplay(input.value);
    }
  });

  // Sync include sold checkboxes based on URL state
  syncIncludeSoldCheckboxes();
});

// Make functions globally available
window.handleTitleOnlySearch = handleTitleOnlySearch;
window.cleanSearchTermForDisplay = cleanSearchTermForDisplay;
window.syncIncludeSoldCheckboxes = syncIncludeSoldCheckboxes;
